export default __webpack_public_path__ + "static/media/darkroast.11eb066a.jpg";